import { User as SupabaseUser } from "@supabase/supabase-js"
import { User } from "./user"

export type { User }

export interface BaseEntity {
  id: string;
  created_at: string;
  updated_at: string;
}

export class ApiError extends Error {
  constructor(message: string, public code?: string) {
    super(message)
    this.name = "ApiError"
  }
}

// Função auxiliar para converter usuário do Supabase para nosso modelo
export function mapUserData(user: SupabaseUser): User {
  console.log("mapUserData - user_metadata:", user.user_metadata);
  console.log("mapUserData - avatar_url:", user.user_metadata?.avatar_url);
  
  // Verificar se o avatar é a URL problemática e substituir por null
  const avatarUrl = user.user_metadata?.avatar_url === 'https://ui.shadcn.com/avatars/shadcn.jpg' 
    ? null 
    : user.user_metadata?.avatar_url || null;
  
  if (user.user_metadata?.avatar_url === 'https://ui.shadcn.com/avatars/shadcn.jpg') {
    console.warn('DETECTADA URL DO SHADCN NO MAPEAMENTO!');
  }
  
  // Verificar se o usuário é administrador baseado no role
  const role = user.user_metadata?.role || "user";
  const isAdmin = role === "admin";
  
  return {
    id: user.id,
    email: user.email || "",
    name: user.user_metadata?.name || "",
    role: role,
    photoUrl: avatarUrl,
    current_plan: user.user_metadata?.current_plan || null,
    plan_start_date: user.user_metadata?.plan_start_date || null,
    plan_end_date: user.user_metadata?.plan_end_date || null,
    plan_failed: false,
    created_at: user.created_at || new Date().toISOString(),
    updated_at: user.updated_at || new Date().toISOString(),
    is_admin: isAdmin
  }
}

export function mapSupabaseUser(user: SupabaseUser): User {
  return mapUserData(user)
} 